import "./donutChart.css";
import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { CustomTooltipDonutProps, DonutChartProps } from "./donutChart.props";
import { vars } from "../../../../assets";

interface CustomTooltipPayload {
  name: string;
  value: number;
  color: string;
  icon?: string;
}

const CustomTooltipDonut: React.FC<CustomTooltipDonutProps> = ({
  active,
  payload,
  label,
  currencySymbol,
  color,
}) => {
  if (!active || !payload?.length) return null;

  const item = payload[0].payload as CustomTooltipPayload;
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        padding: 14,
        border: "1px solid #e6e6e6",
        minWidth: 180,
      }}
    >
      <div className="donutChart-tooltip">
        <div className="donutChart-tooltip-dot" style={{ background: color }} />
        <div className="donutChart-tooltip-name">
          {item.name} {label}
        </div>
        <div className="donutChart-tooltip-value" style={{ color }}>
          {item.value}
          {currencySymbol}
        </div>
      </div>
    </div>
  );
};

const OperationDonutChart: React.FC<DonutChartProps> = ({
  className,
  data,
  currencySymbol,
  arrayRandomColors,
}) => {
  return (
    <>
      <div className={`donutChart-wrapper ${className}`}>
        <PieChart width={178} height={178}>
          <Pie
            data={data as any}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={85}
            paddingAngle={2} // espacio entre items
            cornerRadius={10} // bordes redondeados
            dataKey="value"
          >
            {data.map((entry: any, index: number) => {
              const color: string = entry?.color?.length
                ? entry?.color
                : arrayRandomColors?.[index];

              return <Cell key={`cell-${index}`} fill={color} color={color} />;
            })}

            <Tooltip
              content={({ active, payload, label }) => {
                const color = payload[0]?.payload?.color;

                return (
                  <CustomTooltipDonut
                    active={!!active}
                    payload={payload}
                    label={`${label ?? ""}`}
                    currencySymbol={currencySymbol}
                    color={color}
                  />
                );
              }}
            />
          </Pie>
        </PieChart>
      </div>
    </>
  );
};

export default OperationDonutChart;
